/* =========================================================
   NVQ QUICK BUY — snelkoop vanaf de productkaart
   Werkt samen met:
     snippets/nvq-quick-buy-drawer.liquid  (huls)
     sections/nvq-quick-buy.liquid         (inhoud)
     assets/nvq-quick-buy.css              (opmaak)
   ========================================================= */

(function () {
  'use strict';

  if (window.NvqQuickBuy) return;

  var SECTION_ID = 'nvq-quick-buy';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var cache = new Map();

  var drawer = null;
  var dialog = null;
  var target = null;
  var lastTrigger = null;
  var keydownHandler = null;
  var closeTimer = null;

  /* ---------------------------------------------------------
     Hulpfuncties
  --------------------------------------------------------- */

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function label(name, fallback) {
    if (!drawer) return fallback;
    var value = drawer.getAttribute('data-nvq-qb-label-' + name);
    return value || fallback;
  }

  /* Scripts die via innerHTML binnenkomen worden niet uitgevoerd.
     Voor onder meer de Shop Pay-afbetalingsregel zetten we ze opnieuw. */
  function runScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type.indexOf('json') !== -1) return;

      var fresh = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        fresh.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      fresh.textContent = old.textContent;
      old.parentNode.replaceChild(fresh, old);
    });
  }

  /* ---------------------------------------------------------
     Openen en sluiten van de lade
  --------------------------------------------------------- */

  function trapFocus(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer(trigger) {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    lastTrigger = trigger || null;
    drawer.setAttribute('data-nvq-qb-open', 'true');
    document.body.setAttribute('data-nvq-qb-locked', 'true');

    /* Eerst zichtbaar maken, daarna pas de schuifanimatie starten. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.setAttribute('data-nvq-qb-visible', 'true');
      });
    });

    keydownHandler = trapFocus;
    document.addEventListener('keydown', keydownHandler);
  }

  function closeDrawer() {
    if (!drawer || drawer.getAttribute('data-nvq-qb-open') !== 'true') return;

    drawer.setAttribute('data-nvq-qb-visible', 'false');
    document.body.removeAttribute('data-nvq-qb-locked');

    if (keydownHandler) {
      document.removeEventListener('keydown', keydownHandler);
      keydownHandler = null;
    }

    closeTimer = setTimeout(function () {
      drawer.setAttribute('data-nvq-qb-open', 'false');
      target.innerHTML = '';
      closeTimer = null;
    }, 420);

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  /* ---------------------------------------------------------
     Inhoud ophalen
  --------------------------------------------------------- */

  function fetchContent(productUrl) {
    if (cache.has(productUrl)) {
      return Promise.resolve(cache.get(productUrl));
    }

    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', SECTION_ID);

    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Kon product niet laden');
        return response.text();
      })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var content = holder.querySelector('[data-nvq-qb-content]');
        if (!content) throw new Error('Geen productinhoud gevonden');
        var markup = content.outerHTML;
        cache.set(productUrl, markup);
        return markup;
      });
  }

  function loadProduct(productUrl) {
    drawer.setAttribute('data-nvq-qb-loading', 'true');
    target.innerHTML = '';

    return fetchContent(productUrl)
      .then(function (markup) {
        target.innerHTML = markup;
        runScripts(target);
        drawer.setAttribute('data-nvq-qb-loading', 'false');
        initContent(target.querySelector('[data-nvq-qb-content]'));
      })
      .catch(function () {
        drawer.setAttribute('data-nvq-qb-loading', 'false');
        target.innerHTML =
          '<div class="nvq-qb__panel"><p class="nvq-qb__error">' +
          label('error', 'Något gick fel, försök igen.') +
          '</p></div>';
      });
  }

  /* ---------------------------------------------------------
     Levering: eerstvolgende werkdagen
  --------------------------------------------------------- */

  function deliveryDate(workingDays) {
    var date = new Date();
    var added = 0;
    while (added < workingDays) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }

  function formatDate(date) {
    var locale = document.documentElement.lang || 'sv-SE';
    try {
      return date.toLocaleDateString(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      });
    } catch (e) {
      return date.toLocaleDateString();
    }
  }

  /* ---------------------------------------------------------
     Inhoud tot leven brengen
  --------------------------------------------------------- */

  function initContent(content) {
    if (!content) return;

    var variants = [];
    var json = content.querySelector('[data-nvq-qb-variants]');
    if (json) {
      try {
        variants = JSON.parse(json.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var form = content.querySelector('[data-nvq-qb-form]');
    var variantInput = content.querySelector('[data-nvq-qb-variant-id]');
    var atc = content.querySelector('[data-nvq-qb-atc]');
    var atcLabel = content.querySelector('[data-nvq-qb-atc-label]');
    var errorBox = content.querySelector('[data-nvq-qb-error]');
    var optionGroups = Array.prototype.slice.call(content.querySelectorAll('[data-nvq-qb-option]'));
    var threshold = parseInt(content.getAttribute('data-nvq-qb-threshold'), 10) || 10;
    var forceLow = drawer && drawer.getAttribute('data-nvq-qb-force-low') === 'true';

    /* ---- Leverdatum invullen ---- */
    var deliveryEl = content.querySelector('[data-nvq-qb-delivery]');
    if (deliveryEl) {
      var days = parseInt(content.getAttribute('data-nvq-qb-delivery-days'), 10);
      if (isNaN(days)) days = 2;
      var prefix = deliveryEl.textContent.trim();
      deliveryEl.textContent = (prefix ? prefix + ' ' : '') + formatDate(deliveryDate(days));
    }

    /* ---- Galerij ---- */
    var track = content.querySelector('[data-nvq-qb-gallery-track]');
    var gallery = content.querySelector('[data-nvq-qb-gallery]');
    var dots = Array.prototype.slice.call(content.querySelectorAll('[data-nvq-qb-dot]'));

    function markDot(index) {
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if (track && dots.length) {
      var scrollTick = null;
      track.addEventListener('scroll', function () {
        if (scrollTick) return;
        scrollTick = setTimeout(function () {
          scrollTick = null;
          var slides = track.querySelectorAll('.nvq-qb__media');
          if (!slides.length) return;
          var index = Math.round(track.scrollLeft / (track.scrollWidth / slides.length));
          markDot(Math.min(index, slides.length - 1));
        }, 90);
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var slides = track.querySelectorAll('.nvq-qb__media');
          if (slides[i]) {
            slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });
    }

    function showMedia(mediaId) {
      if (!mediaId || !track) return;
      var slide = track.querySelector('[data-nvq-qb-media-id="' + mediaId + '"]');
      if (!slide) return;

      var desktop = window.matchMedia('(min-width: 990px)').matches;
      if (desktop && gallery) {
        /* Meten ten opzichte van het beeld houdt het scrollen kloppend,
           ook nu er ruimte (padding) rond de fotokolom zit. */
        var offset = slide.getBoundingClientRect().top - gallery.getBoundingClientRect().top;
        gallery.scrollTo({ top: gallery.scrollTop + offset, behavior: 'smooth' });
      } else {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        var slides = Array.prototype.slice.call(track.querySelectorAll('.nvq-qb__media'));
        markDot(slides.indexOf(slide));
      }
    }

    /* ---- Gekozen opties uitlezen ---- */
    function selectedValues() {
      return optionGroups.map(function (group) {
        var select = group.querySelector('[data-nvq-qb-select]');
        if (select) return select.value;
        var swatch = group.querySelector('[data-nvq-qb-selected="true"]');
        return swatch ? swatch.getAttribute('data-nvq-qb-value') : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === values[index];
        });
      });
    }

    /* Een waarde is beschikbaar als er een leverbare variant bestaat die
       de overige gekozen opties respecteert. */
    function valueAvailable(index, value) {
      var values = selectedValues();
      return variants.some(function (variant) {
        if (!variant.available) return false;
        return variant.options.every(function (option, i) {
          if (i === index) return option === value;
          if (values[i] === null || values[i] === undefined) return true;
          return option === values[i];
        });
      });
    }

    function markAvailability() {
      optionGroups.forEach(function (group) {
        var index = parseInt(group.getAttribute('data-nvq-qb-option-index'), 10);

        group.querySelectorAll('[data-nvq-qb-value]').forEach(function (swatch) {
          var value = swatch.getAttribute('data-nvq-qb-value');
          swatch.setAttribute('data-nvq-qb-unavailable', valueAvailable(index, value) ? 'false' : 'true');
        });

        var select = group.querySelector('[data-nvq-qb-select]');
        if (select) {
          Array.prototype.forEach.call(select.options, function (option) {
            var free = valueAvailable(index, option.value);
            option.disabled = !free;
            if (!free && option.textContent.indexOf(' —') === -1) {
              option.textContent = option.textContent + ' — ' + label('soldout', 'Slut i lager');
            } else if (free) {
              option.textContent = option.textContent.split(' —')[0];
            }
          });
        }
      });
    }

    /* ---- Beeld bijwerken bij een gekozen variant ---- */
    var priceCurrent = content.querySelector('[data-nvq-qb-price-current]');
    var priceCompare = content.querySelector('[data-nvq-qb-price-compare]');
    var saveBadge = content.querySelector('[data-nvq-qb-save]');
    var saveAmount = content.querySelector('[data-nvq-qb-save-amount]');
    var stockLabel = content.querySelector('[data-nvq-qb-stock-label]');
    var stockDot = content.querySelector('[data-nvq-qb-stock-dot]');
    var stockBar = content.querySelector('[data-nvq-qb-stock-bar]');

    function updateStock(variant) {
      if (!stockLabel) return;

      if (!variant || !variant.available) {
        stockLabel.textContent = label('soldout', 'Slut i lager');
        if (stockDot) stockDot.className = 'nvq-qb__dot nvq-qb__dot--out';
        if (stockBar) stockBar.hidden = true;
        return;
      }

      var tracked = variant.inventory_management === 'shopify';
      var quantity = variant.inventory_quantity;
      var low = tracked && variant.inventory_policy !== 'continue' && quantity > 0 && quantity <= threshold;

      /* Wordt de voorraad niet in Shopify bijgehouden, dan is er geen aantal
         om op te rekenen. Met deze schakelaar toont de snelkoop dan dezelfde
         melding als het blok op de productpagina, zodat er niet op één
         scherm "I lager" naast "Nästan slutsåld" staat. De voortgangsbalk
         blijft weg: zonder echt aantal valt er niets te vullen. */
      if (!low && forceLow && !tracked) {
        stockLabel.textContent = label('lowstock', 'Endast få kvar');
        if (stockDot) stockDot.className = 'nvq-qb__dot nvq-qb__dot--low';
        if (stockBar) stockBar.hidden = true;
        return;
      }

      if (low) {
        stockLabel.textContent = label('lowstock', 'Endast få kvar');
        if (stockDot) stockDot.className = 'nvq-qb__dot nvq-qb__dot--low';
        if (stockBar) {
          stockBar.hidden = false;
          var fill = stockBar.querySelector('span');
          if (fill) {
            var percent = Math.max(12, Math.round((quantity / threshold) * 100));
            fill.style.width = percent + '%';
          }
        }
      } else {
        stockLabel.textContent = label('instock', 'I lager');
        if (stockDot) stockDot.className = 'nvq-qb__dot';
        if (stockBar) stockBar.hidden = true;
      }
    }

    function update(variant) {
      if (variantInput) variantInput.value = variant ? variant.id : '';

      if (variant) {
        if (priceCurrent) {
          priceCurrent.textContent = variant.price_formatted;
          priceCurrent.classList.toggle('nvq-qb__price-current--sale', !!variant.compare_formatted);
        }
        if (priceCompare) {
          priceCompare.hidden = !variant.compare_formatted;
          priceCompare.textContent = variant.compare_formatted || '';
        }
        if (saveBadge) {
          saveBadge.hidden = !variant.save_formatted;
          if (saveAmount) saveAmount.textContent = variant.save_formatted || '';
        }
        showMedia(variant.media_id);
      }

      updateStock(variant);

      if (atc) {
        atc.disabled = !variant || !variant.available;
      }
      if (atcLabel) {
        if (!variant) {
          atcLabel.textContent = label('choose', 'Välj ett alternativ');
        } else if (!variant.available) {
          atcLabel.textContent = label('soldout', 'Slut i lager');
        } else {
          atcLabel.textContent = label('atc', 'Lägg i varukorg');
        }
      }
    }

    function refresh() {
      var values = selectedValues();

      optionGroups.forEach(function (group, i) {
        var display = group.querySelector('[data-nvq-qb-option-selected]');
        if (display) display.textContent = values[i] || '';
      });

      markAvailability();
      update(findVariant(values));
    }

    /* ---- Luisteren naar keuzes ---- */
    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-nvq-qb-value]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          group.querySelectorAll('[data-nvq-qb-value]').forEach(function (other) {
            other.setAttribute('data-nvq-qb-selected', 'false');
          });
          swatch.setAttribute('data-nvq-qb-selected', 'true');
          refresh();
        });
      });

      var select = group.querySelector('[data-nvq-qb-select]');
      if (select) {
        select.addEventListener('change', refresh);
      }
    });

    /* ---- Aantal ---- */
    var qtyInput = content.querySelector('[data-nvq-qb-qty-input]');
    var qtyMinus = content.querySelector('[data-nvq-qb-qty-minus]');
    var qtyPlus = content.querySelector('[data-nvq-qb-qty-plus]');

    function currentQty() {
      var value = parseInt(qtyInput && qtyInput.value, 10);
      return isNaN(value) || value < 1 ? 1 : value;
    }

    function setQty(value) {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, value);
      if (qtyMinus) qtyMinus.disabled = currentQty() <= 1;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(currentQty() + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(currentQty()); });
    setQty(currentQty());

    /* ---- Toevoegen aan winkelwagen ---- */
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!atc || atc.disabled) return;

        if (errorBox) {
          errorBox.hidden = true;
          errorBox.textContent = '';
        }

        atc.setAttribute('data-nvq-qb-state', 'loading');
        atc.disabled = true;

        addToCart(new FormData(form))
          .then(function () {
            atc.setAttribute('data-nvq-qb-state', 'done');
            setTimeout(function () {
              atc.removeAttribute('data-nvq-qb-state');
              atc.disabled = false;
              closeDrawer();
              openCartDrawer();
            }, 450);
          })
          .catch(function (error) {
            atc.removeAttribute('data-nvq-qb-state');
            atc.disabled = false;
            if (errorBox) {
              errorBox.hidden = false;
              errorBox.textContent = error.message || label('error', 'Något gick fel, försök igen.');
            }
          });
      });
    }

    refresh();

    /* Focus in de lade zetten zodra de inhoud er staat. */
    var focusTarget = dialog.querySelector('[data-nvq-qb-close]:not([tabindex="-1"])');
    if (focusTarget) focusTarget.focus();
  }

  /* ---------------------------------------------------------
     Winkelwagen
  --------------------------------------------------------- */

  function addToCart(formData) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data.description || result.data.message || label('error', 'Något gick fel, försök igen.'));
        }
        document.dispatchEvent(new CustomEvent('nvq:cart:updated', { detail: result.data }));
        refreshCartCount();
        return result.data;
      });
  }

  function refreshCartCount() {
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
          bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* UpCart verzorgt de winkelwagenlade in deze winkel. */
  function openCartDrawer() {
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return;
    }
    document.dispatchEvent(new CustomEvent('nvq:cart:open'));
  }

  /* ---------------------------------------------------------
     Triggers op de productkaarten
  --------------------------------------------------------- */

  function directAdd(trigger) {
    var variantId = trigger.getAttribute('data-nvq-qb-variant');
    if (!variantId) return;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    trigger.setAttribute('data-nvq-qb-state', 'loading');

    addToCart(formData)
      .then(function () {
        trigger.setAttribute('data-nvq-qb-state', 'done');
        openCartDrawer();
        setTimeout(function () {
          trigger.removeAttribute('data-nvq-qb-state');
        }, 1200);
      })
      .catch(function () {
        trigger.removeAttribute('data-nvq-qb-state');
        /* Bij een fout alsnog de lade openen, zodat de klant kan kiezen. */
        var url = trigger.getAttribute('data-nvq-qb-url');
        if (url) {
          openDrawer(trigger);
          loadProduct(url);
        }
      });
  }

  function onTriggerClick(event) {
    var trigger = event.target.closest('[data-nvq-qb-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (trigger.getAttribute('data-nvq-qb-state')) return;

    if (trigger.getAttribute('data-nvq-qb-single') === 'true') {
      directAdd(trigger);
      return;
    }

    var url = trigger.getAttribute('data-nvq-qb-url');
    if (!url) return;

    openDrawer(trigger);
    loadProduct(url);
  }

  /* ---------------------------------------------------------
     Start
  --------------------------------------------------------- */

  function init() {
    drawer = document.querySelector('[data-nvq-qb-drawer]');
    if (!drawer) return;

    dialog = drawer.querySelector('.nvq-qb-drawer__dialog');
    target = drawer.querySelector('[data-nvq-qb-target]');

    drawer.querySelectorAll('[data-nvq-qb-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('click', onTriggerClick);
  }

  window.NvqQuickBuy = {
    open: function (productUrl) {
      if (!drawer) return;
      openDrawer(null);
      loadProduct(productUrl);
    },
    close: closeDrawer,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
